// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__b9qCz","topImage":"styles_topImage__PLEYE","copyIconWrapper":"styles_copyIconWrapper__Rn9Tn","passwordIconWrapper":"styles_passwordIconWrapper__icykB"};